// Tech Stack Tools by Category
// Comprehensive list organized by the 4 audit lenses: Operations, Customer, Sales/Marketing, Team

export const TECH_STACK_TOOLS = {
  operations: {
    id: 'operations',
    label: 'Operations & Efficiency',
    subtitle: 'Which tools do you use for operations?',
    tools: [
      { value: 'project-mgmt', label: 'Project Management (Asana, Monday.com, ClickUp, Trello, Jira, Smartsheet)' },
      { value: 'workflow-automation', label: 'Workflow Connectors (n8n, Workato, Relay.app, Pipedream)' },
      { value: 'agentic-automation', label: 'Supervised AI Workflow Agents (Hermes agents, Claude Code, Codex, Lindy, Relevance AI)' },
      { value: 'finance-accounting', label: 'Finance & Accounting (QuickBooks, Xero, NetSuite, Wave, Sage)' },
      { value: 'document-extraction', label: 'Document / Invoice Extraction (Dext, Veryfi, Nanonets, Docsumo, Hubdoc)' },
      { value: 'inventory-fulfillment', label: 'Inventory & Fulfillment (ShipStation, Cin7, Fishbowl, TradeGecko)' },
      { value: 'scheduling', label: 'Scheduling / Resource Planning (Google Calendar, Motion, Clockify, Harvest)' },
      { value: 'doc-management', label: 'Document Management (Google Workspace, Microsoft 365, Notion, Dropbox, Box)' },
      { value: 'hr-payroll', label: 'HR / Payroll / Time Tracking (Gusto, Rippling, BambooHR, ADP, Deel, Clockify)' },
      { value: 'procurement', label: 'Procurement / Vendor Management (Coupa, Procurify, Precoro)' },
      { value: 'ops-dashboards', label: 'Operations Dashboards / Reporting (Airtable, Coda, Smartsheet, Power BI)' },
      { value: 'facilities-logistics', label: 'Facilities / Logistics (Fleetio, ServiceTitan, Jobber, Odoo)' },
      { value: 'other', label: 'Other (specify your own)', hasInput: true }
    ]
  },
  customer: {
    id: 'customer',
    label: 'Customer Experience',
    subtitle: 'Which tools do you use for customer support?',
    tools: [
      { value: 'help-desk', label: 'Help Desk / Ticketing (Zendesk, Freshdesk, Intercom, Zoho Desk, HelpScout)' },
      { value: 'live-chat', label: 'Live Chat & Messaging (Drift, Tidio, Crisp, Manychat, Twilio, WhatsApp Business)' },
      { value: 'ai-receptionist', label: 'AI Receptionist / Phone Follow-up (Smith.ai, Goodcall, OpenPhone, Dialpad, Aircall)' },
      { value: 'shared-inbox-ai', label: 'Shared Inbox / Email Triage (Front, Missive, Help Scout AI, Zendesk AI)' },
      { value: 'feedback-surveys', label: 'Customer Feedback & Surveys (Typeform, SurveyMonkey, Google Forms, Delighted)' },
      { value: 'knowledge-base', label: 'Knowledge Base / Self-Service (Document360, Helpjuice, Notion, Confluence)' },
      { value: 'scheduling', label: 'Appointment Scheduling (Calendly, Acuity, Chili Piper)' },
      { value: 'video-support', label: 'Video / Screen Share Support (Zoom, Google Meet, Loom)' },
      { value: 'customer-success', label: 'Customer Onboarding / Success (ChurnZero, Gainsight, HubSpot Service Hub)' },
      { value: 'omnichannel', label: 'Omnichannel Communication (Aircall, Dialpad, RingCentral, Teams, Slack)' },
      { value: 'chatbots-ai', label: 'Chatbots / AI Assistants (Intercom Fin, Drift AI, Tidio AI, Forethought)' },
      { value: 'other', label: 'Other (specify your own)', hasInput: true }
    ]
  },
  salesMarketing: {
    id: 'salesMarketing',
    label: 'Sales, Marketing & Growth',
    subtitle: 'Which tools do you use for sales and marketing?',
    tools: [
      { value: 'crm', label: 'CRM (HubSpot, Salesforce, Pipedrive, Zoho CRM)' },
      { value: 'marketing-automation', label: 'Marketing Automation (ActiveCampaign, Marketo, Mailchimp, Klaviyo, HubSpot)' },
      { value: 'lead-gen', label: 'Lead Generation & Enrichment (Apollo, ZoomInfo, Clearbit, Lusha)' },
      { value: 'proposal-quotes', label: 'Proposal / Quote Automation (PandaDoc, Qwilr, Proposify, HubSpot Quotes, Jobber)' },
      { value: 'content-creation', label: 'Content Studio & Repurposing (ChatGPT Team, Claude Team, Canva, Descript, OpusClip)' },
      { value: 'ad-management', label: 'Ad Management & Analytics (Google Ads, Meta Ads Manager, LinkedIn Campaign Manager)' },
      { value: 'seo-sem', label: 'SEO / SEM Tools (Semrush, Ahrefs, Moz)' },
      { value: 'social-media', label: 'Social Media Management (Buffer, Hootsuite, Later, Sprout Social)' },
      { value: 'web-analytics', label: 'Web Analytics (Google Analytics, Looker Studio, Hotjar, Crazy Egg)' },
      { value: 'sales-enablement', label: 'Sales Enablement & Communication (Gong, Outreach, SalesLoft, Chili Piper)' },
      { value: 'affiliate-referral', label: 'Affiliate / Referral / Influencer (Tapfiliate, ReferralCandy, Upfluence)' },
      { value: 'ecommerce-pos', label: 'E-commerce / POS (Shopify, WooCommerce, Stripe, Square)' },
      { value: 'cms-website', label: 'CMS / Website Tools (WordPress, Webflow, Custom Build)' },
      { value: 'other', label: 'Other (specify your own)', hasInput: true }
    ]
  },
  team: {
    id: 'team',
    label: 'Team & Decision-Making',
    subtitle: 'Which tools do you use for collaboration and data?',
    tools: [
      { value: 'internal-comms', label: 'Internal Communication (Slack, Microsoft Teams, Google Chat)' },
      { value: 'knowledge-mgmt', label: 'Knowledge Management (Notion, Confluence, Guru)' },
      { value: 'sop-assistant', label: 'SOP / Knowledge Assistants (ChatGPT Team, Claude Team, Notion AI, Guru, Glean)' },
      { value: 'bi-analytics', label: 'BI & Analytics (Tableau, Power BI, Looker, Mode Analytics, Retool)' },
      { value: 'performance-okr', label: 'Performance & OKR Tracking (Lattice, 15Five, Leapsome, Profit.co)' },
      { value: 'doc-collab', label: 'Document Collaboration (Google Docs, Coda, Miro, FigJam)' },
      { value: 'meeting-productivity', label: 'Meeting Productivity (Fellow, Hugo, Fireflies.ai, Otter.ai)' },
      { value: 'data-viz', label: 'Data Visualization / Dashboards (Databox, Geckoboard, Grow)' },
      { value: 'ai-dashboard-summaries', label: 'AI Dashboard Summaries (Databox, Power BI Copilot, Tableau Pulse, Zoho Analytics)' },
      { value: 'decision-support', label: 'Decision Support / Forecasting (Pigment, Mosaic, Abacum)' },
      { value: 'other', label: 'Other (specify your own)', hasInput: true }
    ]
  }
};

// Helper function to get tools for a category
export const getToolsForCategory = (categoryId) => {
  return TECH_STACK_TOOLS[categoryId]?.tools || [];
};

// Helper function to get category label
export const getTechStackCategoryLabel = (categoryId) => {
  return TECH_STACK_TOOLS[categoryId]?.label || '';
};

// Helper function to get category subtitle
export const getTechStackSubtitle = (categoryId) => {
  return TECH_STACK_TOOLS[categoryId]?.subtitle || '';
};

// Integration rating question text
export const INTEGRATION_RATING_QUESTION = "How well do these tools integrate with each other?";

// Integration rating scale labels
export const INTEGRATION_RATING_LABELS = {
  1: "Poorly - Lots of manual work",
  2: "Somewhat - Some integrations exist",
  3: "Moderately - Most tools connect",
  4: "Well - Good automation",
  5: "Seamlessly - Fully integrated"
};
